export default {
  OPEN: "open",
  Rr: "purchase",
  hr: "push_click",
  Ee: "custom_event",
  Zr: "iam_click",
  As: "test",
};
